import React, { useState, useEffect, forwardRef } from 'react';
import Animation from './Animation';

const Hero: React.ForwardRefRenderFunction<HTMLElement> = (props, ref) => {
  const [typedText, setTypedText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const textOptions = ['ReactJS Developer', 'ASP.NET Web API Developer', 'Next.js Developer', 'TypeScript Expert'];
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    const typeText = () => {
      const currentOption = textOptions[currentTextIndex];

      if (isTyping) {
        if (charIndex < currentOption.length) {
          setTypedText(currentOption.substring(0, charIndex + 1));
          setCharIndex(charIndex + 1);
        } else {
          setIsTyping(false);
          setTimeout(() => {}, 1500); // Pause at the end of typing
        }
      } else {
        if (charIndex > 0) {
          setTypedText(currentOption.substring(0, charIndex - 1));
          setCharIndex(charIndex - 1);
        } else {
          setIsTyping(true);
          setCurrentTextIndex((currentTextIndex + 1) % textOptions.length);
        }
      }
    };

    const typingTimer = setTimeout(typeText, isTyping ? 100 : 50);
    return () => clearTimeout(typingTimer);
  }, [charIndex, currentTextIndex, isTyping, textOptions]);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      window.scrollTo({
        top: contactSection.offsetTop - 70,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center hero-gradient" ref={ref}>
      <div className="absolute inset-0 bg-black opacity-60"></div>
      <div className="container mx-auto px-4 z-10">
        <div className="max-w-3xl animate-fade-in">
          <p className="text-primary font-semibold text-lg mb-4">WELCOME TO MY PORTFOLIO</p>
          <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
            Hi, I'm <span className="text-primary">Zeeshan Mehboob</span>
          </h1>
          <div className="h-16">
            <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-6">
              <span>I'm a </span>
              <span className="text-primary">{typedText}</span>
              <span className="animate-pulse">|</span>
            </h2>
          </div>
          <p className="text-gray-300 text-lg md:text-xl mb-8 max-w-2xl">
            Building seamless digital experiences with modern technologies.
            Passionate about creating efficient, scalable solutions for complex problems.
          </p>
          <div className="flex flex-wrap gap-4">
            <button
              onClick={scrollToContact}
              className="bg-primary hover:bg-blue-600 text-white py-3 px-8 rounded-full transition duration-300 font-semibold"
            >
              Hire Me
            </button>
            <a
              href="#portfolio"
              className="bg-transparent hover:bg-white/10 text-white border-2 border-white py-3 px-8 rounded-full transition duration-300 font-semibold"
            >
              View My Work
            </a>
          </div>
        </div>
      </div>
      <Animation />
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <a href="#about" className="flex flex-col items-center">
          <span className="mb-2">Scroll Down</span>
          <i className="fas fa-chevron-down"></i>
        </a>
      </div>
    </section>
  );
};

export default forwardRef(Hero);